export const getGame = source => fetch(source)
  .then(response => response.json())
  .catch(data => console.error(data));
